import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../shared/api.service';

@Injectable({
    providedIn: 'root'
})
export class InfonavitCreditService {

    constructor(private api: ApiService) { }

    get(employeeId: number | string): Observable<any> {
        return this.api.get(`hr/employee/${employeeId}/infonavit-credit`);
    }

    add(employeeId: number | string, payload: any): Observable<any> {
        return this.api.post(`hr/employee/${employeeId}/infonavit-credit/add`, payload);
    }

    events(employeeId: number | string): Observable<any> {
        return this.api.get(`hr/employee/${employeeId}/infonavit-credit/events`);
    }
}
